import type { AiExecutionGraph, AiRollbackPlan } from '../../types/aiOperational'
import { RollbackAvailabilityIndicator } from './RollbackAvailabilityIndicator'

export const RollbackAvailabilityPanel = ({
  rollback,
  graph,
}: {
  rollback?: AiRollbackPlan | null
  graph?: AiExecutionGraph | null
}) => {
  const contracts = graph?.rollbackContracts ?? (rollback?.contract ? [rollback.contract] : [])
  if (!rollback && !contracts.length) return null
  return (
    <section className="aiExecutionRollbackPanel" aria-label="Rollback availability">
      <div className="aiExecutionPanelHeader">
        <strong>Rollback</strong>
        <RollbackAvailabilityIndicator rollback={rollback} />
      </div>
      {contracts.length ? (
        <ul>
          {contracts.slice(0, 3).map((contract) => (
            <li key={contract.id}>
              <span>{contract.restorationMode.toLowerCase().replace(/_/g, ' ')}</span>
              <small>{contract.authority.toLowerCase().replace(/_/g, ' ')} · {contract.operationIds.length} operation link{contract.operationIds.length === 1 ? '' : 's'}</small>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  )
}
